import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Apps = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M8.75 13C9.99264 13 11 14.0074 11 15.25V18.75C11 19.9926 9.99264 21 8.75 21H5.25C4.00736 21 3 19.9926 3 18.75V15.25C3 14.0074 4.00736 13 5.25 13H8.75ZM18.75 13C19.9926 13 21 14.0074 21 15.25V18.75C21 19.9926 19.9926 21 18.75 21H15.25C14.0074 21 13 19.9926 13 18.75V15.25C13 14.0074 14.0074 13 15.25 13H18.75ZM5.25 14.5C4.83579 14.5 4.5 14.8358 4.5 15.25V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H8.75C9.16421 19.5 9.5 19.1642 9.5 18.75V15.25C9.5 14.8358 9.16421 14.5 8.75 14.5H5.25ZM15.25 14.5C14.8358 14.5 14.5 14.8358 14.5 15.25V18.75C14.5 19.1642 14.8358 19.5 15.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V15.25C19.5 14.8358 19.1642 14.5 18.75 14.5H15.25ZM8.75 3C9.99264 3 11 4.00736 11 5.25V8.75C11 9.99264 9.99264 11 8.75 11H5.25C4.00736 11 3 9.99264 3 8.75V5.25C3 4.00736 4.00736 3 5.25 3H8.75ZM17 3C17.4418 3 17.7997 3.35807 17.7998 3.7998V6.2002H20.2002C20.6419 6.2003 21 6.55824 21 7C21 7.44176 20.6419 7.7997 20.2002 7.7998H17.7998V10.2002C17.7996 10.6418 17.4417 11 17 11C16.5583 11 16.2004 10.6418 16.2002 10.2002V7.7998H13.7998C13.3582 7.79959 13 7.4417 13 7C13 6.5583 13.3582 6.20041 13.7998 6.2002H16.2002V3.7998C16.2003 3.35807 16.5582 3 17 3ZM5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25V8.75C4.5 9.16421 4.83579 9.5 5.25 9.5H8.75C9.16421 9.5 9.5 9.16421 9.5 8.75V5.25C9.5 4.83579 9.16421 4.5 8.75 4.5H5.25Z'
        fill='currentColor'
      />
    ) : (
      <>
        <path
          d='M17 3C17.4418 3 17.8 3.35817 17.8 3.8V6.2H20.2C20.6418 6.2 21 6.55817 21 7C21 7.44183 20.6418 7.8 20.2 7.8H17.8V10.2C17.8 10.6418 17.4418 11 17 11C16.5582 11 16.2 10.6418 16.2 10.2V7.8H13.8C13.3582 7.8 13 7.44183 13 7C13 6.55817 13.3582 6.2 13.8 6.2H16.2V3.8C16.2 3.35817 16.5582 3 17 3Z'
          fill='currentColor'
        />
        <path
          d='M15 13C13.8954 13 13 13.8954 13 15V19C13 20.1046 13.8954 21 15 21H19C20.1046 21 21 20.1046 21 19V15C21 13.8954 20.1046 13 19 13H15Z'
          fill='currentColor'
        />
        <path
          d='M3 15C3 13.8954 3.89543 13 5 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H5C3.89543 21 3 20.1046 3 19V15Z'
          fill='currentColor'
        />
        <path
          d='M5 3C3.89543 3 3 3.89543 3 5V9C3 10.1046 3.89543 11 5 11H9C10.1046 11 11 10.1046 11 9V5C11 3.89543 10.1046 3 9 3H5Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
